import { OrderState } from "@/model/OrderState";
import dayjs, { Dayjs } from 'dayjs';

export class HistoryFilterRequest {

    public startDate: Dayjs = dayjs().date(1);
    public endDate: Dayjs = dayjs();
    public status: OrderState = null;
    public searchTerms: string = '';
    public driveIds: string[] = [];

}
